import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@utex/ui-kit';
import { IconAlfaBank, IconSberbank, IconTinkoff } from '../Icons';
import { ButtonsWrapper } from './styles';

export const Instruction = () => {
  const { t } = useTranslation('byBank');
  return (
    <>
      <Typography.Paragraph size="M" weight="bold">
        {t('If you have one of these banks read the instructions')}
      </Typography.Paragraph>
      <ButtonsWrapper>
        <Button
          icon={<IconSberbank />}
          view="success-dim"
          as="a"
          href="https://investment-s3.unitedtraders.com/files/swift/swift_sber.pdf"
          target="_blank"
        >
          {t('Sberbank')}
        </Button>
        <Button
          icon={<IconAlfaBank />}
          view="alert-dim"
          as="a"
          href="https://investment-s3.unitedtraders.com/files/swift/swift_alfa.pdf"
          target="_blank"
        >
          {t('Alfa-Bank')}
        </Button>
        <Button
          icon={<IconTinkoff />}
          view="warning-dim"
          as="a"
          href="https://investment-s3.unitedtraders.com/files/swift/swift_tinkoff.pdf"
          target="_blank"
        >
          {t('Tinkoff')}
        </Button>
      </ButtonsWrapper>
    </>
  );
};
